// extracted by mini-css-extract-plugin
export default {"wrapper":"News_wrapper__nfjL0"};